/*
 * Copyright (c) 2019-2021 LogMeIn
 * All Rights Reserved Worldwide.
 *
 * THIS PROGRAM IS CONFIDENTIAL AND PROPRIETARY TO LOGMEIN
 * AND CONSTITUTES A VALUABLE TRADE SECRET.
 */

import {
  ButtonProps,
  Button as ChakraButton,
} from '@getgo/chameleon-chakra-ui';
import React from 'react';
import { Spacing } from '../../themes/GoToTheme';

interface DefaultButtonProps extends ButtonProps {
  link?: string;
}

interface StyledButtonProps extends DefaultButtonProps {
  secondary?: boolean;
}

export const StyledButton: React.FC<StyledButtonProps> = (props) => {
  const { secondary, ...rest } = props;

  return secondary ? (
    <DefaultStyledButton variant='outline' colorScheme='green' {...rest} />
  ) : (
    <DefaultStyledButton {...rest} />
  );
};

const DefaultStyledButton: React.FC<DefaultButtonProps> = (props) => {
  const { link, ...rest } = props;

  return (
    <ChakraButton
      as='a'
      minWidth='auto'
      href={link}
      size='xl'
      paddingX={Spacing.CoreLayout1}
      {...rest}
    />
  );
};
